import { memo, useCallback, useMemo } from 'react';
import { TouchableButton } from '@components/common/Touchable';
import { TOOL_BUTTONS, KEYS } from './constants';
import cn from 'classnames';
import { LABEL } from '@veriables';

const buttonStyle = {
  fontSize: '0.875rem',
  fontWeight: '700',
  opacity: 1,
};

const ActionButtons = ({
  serverAppTheme = {},
  onCancel = () => {},
  onActionClick = () => {},
  buttonDisable,
  buttonVisibility,
  thirdPartyAppName,
  buttonLabels = {},
}) => {
  const visibleButtons = useMemo(
    () => TOOL_BUTTONS.filter(btn => buttonVisibility[btn.key]),
    [buttonVisibility]
  );

  const handleActionClick = useCallback(
    (event, key) => {
      event.preventDefault();
      onActionClick(key);
    },
    [onActionClick]
  );

  const handleCancel = useCallback(
    event => {
      event.preventDefault();
      onCancel();
    },
    [onCancel]
  );

  return (
    <div className="d-flex flex-wrap">
      {visibleButtons.map(btn => (
        <div key={btn.key} className={cn('pb-1 pr-1')} style={{ width: '25%' }}>
          <TouchableButton
            type="button"
            className={cn('rounded btn-ripple w-100', 'btn35')}
            style={{
              ...buttonStyle,
              background: buttonDisable[btn.key]
                ? serverAppTheme?.primary_btn_disable
                : serverAppTheme?.secondaryBtn,
              color: buttonDisable[btn.key]
                ? serverAppTheme?.btn_font_color_disabled
                : serverAppTheme?.btn_font_color,
            }}
            onClick={event => handleActionClick(event, btn.key)}
            disabled={buttonDisable[btn.key]}
          >
            {buttonLabels[btn.key] ||
              btn.label ||
              (btn.key === KEYS.LAUNCH_EXTERNAL_APP && thirdPartyAppName)}
          </TouchableButton>
        </div>
      ))}
      <div
        className={cn('pb-1 pr-1')}
        style={{ width: '25%', marginLeft: 'auto' }}
      >
        <TouchableButton
          type="button"
          className={cn('rounded btn-ripple w-100', 'btn35')}
          style={{
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            border: serverAppTheme?.cancleBtn_Border,
            color: serverAppTheme?.cancleBtn_font,
          }}
          onClick={handleCancel}
        >
          {LABEL().CANCEL}
        </TouchableButton>
      </div>
    </div>
  );
};

export default memo(ActionButtons);
